var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStellaswapLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 932.66 190.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 11304.32,
    y1: 100.72,
    x2: 11452.08,
    y2: 100.72,
    gradientTransform: "matrix(-1 0 0 1 11484.75 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2107b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#301748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 11412.83,
    y1: 89.3,
    x2: 11421.79,
    y2: 89.3,
    gradientTransform: "matrix(-1 0 0 1 11484.75 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2107b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#301748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d1126"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 11398.53,
    y1: 27.7,
    x2: 11407.71,
    y2: 27.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 11451.73,
    y1: 72.2,
    x2: 11460.01,
    y2: 72.2,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 11304.59,
    y1: 145.03,
    x2: 11378.39,
    y2: 116.58,
    gradientTransform: "matrix(-1 0 0 1 11484.75 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d1126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#301748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2107b"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-7{fill:#3b454e;stroke:#3b454e;stroke-linecap:round;stroke-linejoin:round;stroke-width:4.37px}"))), /*#__PURE__*/React.createElement("circle", {
    cx: 95.06,
    cy: 95.06,
    r: 95.06,
    style: {
      fill: "#301748"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.67 158.37a95.23 95.23 0 0 1-9-9.52c-6.63-8.53-21.4-23.53-25.07-27.27-4.23-4.31-8.5-8.61-12.69-13-.61-.63-1.6-1.36-1-2.42s1.76-.9 2.78-.84a4.35 4.35 0 0 1 1.33.3q4.5 1.78 9 3.61c6 2.42 11.87 4.93 17.88 7.2 3.62 1.37 5.15 0 4.47-3.79-.57-3.17-1.37-6.28-2.22-9.4A4.93 4.93 0 0 1 88.31 97c1.24-.18 2.49-.21 3.73-.31s2.51-.4 3-1.84A3.17 3.17 0 0 0 94 91.23c-4.08-3.93-8.11-7.9-12.15-11.88q-15.18-15-30.34-30-9-8.85-17.92-17.69c-.59-.58-1.21-1.09-.74-2s1.26-.8 2.07-.64c2.48.5 4.27 2.28 6.23 3.62 5.23 3.6 10.7 6.82 16 10.23 3.7 2.35 7.46 4.61 11.15 7s7.19 4.75 10.82 7.06c5.22 3.31 10.49 6.53 15.7 9.85 5.62 3.58 11.2 7.22 16.78 10.86 1 .66 1.93 1 3 .06s.91-1.88.43-3.15c-1.12-3-3.21-5.42-4-8.49-.28-1-.5-2 .5-2.78a2.42 2.42 0 0 1 2.86-.13 114 114 0 0 1 11.05 6A113.17 113.17 0 0 0 139 76.42c7.61 3.62 14.88 7.86 22.08 12.16a35.19 35.19 0 0 1 10.07 9.7 45.18 45.18 0 0 1 5.21 9.27 56.76 56.76 0 0 1 3.83 14.87c1.18 9.12-2.15 20.84-6.4 27.12a51.38 51.38 0 0 1-13.9 14.52 57 57 0 0 1-12 6.23c-4.43 1.74-9 2-13.91 2.18a9.63 9.63 0 0 1-1.2 0c-10.12-.61-20.08-2.05-34.11-14.1Zm65.51-30.46a29.71 29.71 0 0 0-30-30.32c-16.06.09-29.28 13.2-29.33 30.54 0 14.18 13.81 30 29.5 29 16.21.66 29.73-13.98 29.83-29.22Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 89.3a4.66 4.66 0 0 0 4.5 4.7 4.47 4.47 0 0 0 4.42-4.79 4.79 4.79 0 0 0-4.69-4.59A4.56 4.56 0 0 0 63 89.3Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.91 32.11c2.71 0 4.32-1.74 4.31-4.51a4.61 4.61 0 0 0-4.42-4.32c-2 0-4.75 2.54-4.77 4.45a4.65 4.65 0 0 0 4.88 4.38Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 72.18a3.93 3.93 0 0 0-4.13-4.12 4.57 4.57 0 0 0-4.15 4.31 4.32 4.32 0 0 0 4.15 4A4 4 0 0 0 33 72.18Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.35 157.08c16.21.71 29.73-13.93 29.83-29.17a29.71 29.71 0 0 0-30-30.32c-16.06.09-29.28 13.2-29.33 30.54-.05 14.18 13.81 29.95 29.5 28.95Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M239.51 121.54c8.32 5.84 18.09 11.24 29.47 11.24 12 0 20.43-5.69 20.43-13.57 0-8.17-4.82-11.38-14.3-14.88l-14.15-5c-15-5.4-22-13.42-22-25.39 0-14.88 12-24.22 31.07-24.22a52.07 52.07 0 0 1 27.43 7.74v13.31c-8-5.83-16.63-9.48-26.85-9.48-11.38 0-18.82 5.25-18.82 12.69s5.84 10.8 13.86 13.86L279.78 93c15.75 5.83 22.46 13.57 22.46 26.26 0 15.61-12.54 25.09-33 25.09a53.39 53.39 0 0 1-29.76-9.63ZM352.72 142c-8.75 2.92-15.75 2.77-20.27-.29-4.38-3.36-6.42-8.9-6.42-17.07v-36.8h-8.9V76.75H326V60.41h11.81v16.34h11v11.09h-11v36c0 3.79.73 6.42 2.19 7.58 2.77 2.49 7.73 1 12.69-.29ZM366.44 110c0-17.51 11.82-35.31 32.39-35.31 19 0 30.49 14.74 31.22 29.76 0 1.46.15 2.63.15 7.3h-51.94c.73 13.42 9.77 21.3 24.07 21.3a37.09 37.09 0 0 0 22.47-7v11.52c-6 4.38-13.72 6.57-22.47 6.57-20.28.02-35.89-14.72-35.89-34.14Zm51.79-7.73c-.73-9.34-9-16.49-19.55-16.49s-18.67 7-19.84 16.49ZM450.62 142.12V51.66h11.82v90.46ZM486.66 142.12V51.66h11.81v90.46ZM518.75 122.13c0-12.4 11.53-21.45 27.28-21.45 8.32 0 15.32 2.48 19.7 7v-7.58c0-9-6.42-14.3-18.09-14.3-8 0-14.88 2.92-21 6.42V80.4a50.12 50.12 0 0 1 23.2-5.69c16.78 0 27.72 9.48 27.72 24.51v42.9h-11.83v-5.26c-3.35 3.65-11.09 7.44-19.7 7.44-16.03 0-27.28-9.19-27.28-22.17Zm47.27 0c0-7.88-9.63-11.53-18.38-11.53s-17.07 3.65-17.07 11.53 8.32 11.52 17.07 11.52 18.36-3.5 18.36-11.52ZM598.41 121.54c8.32 5.84 18.09 11.24 29.47 11.24 12 0 20.43-5.69 20.43-13.57 0-8.17-4.82-11.38-14.3-14.88l-14.15-5c-15-5.4-22-13.42-22-25.39 0-14.88 12-24.22 31.07-24.22a52 52 0 0 1 27.43 7.74v13.31c-8-5.83-16.63-9.48-26.84-9.48-11.38 0-18.82 5.25-18.82 12.69s5.83 10.8 13.86 13.86L638.68 93c15.76 5.83 22.47 13.57 22.47 26.26 0 15.61-12.55 25.09-33 25.09a53.4 53.4 0 0 1-29.77-9.63ZM697.91 142.12l-21.59-65.37h11.82l13.71 44.94 13.57-44.94h12.25l13.57 44.94L755 76.75h11.81l-21.59 65.37h-7.92l-15.75-47.86-15.76 47.86ZM780.93 122.13c0-12.4 11.52-21.45 27.28-21.45 8.32 0 15.32 2.48 19.7 7v-7.58c0-9-6.42-14.3-18.09-14.3-8 0-14.89 2.92-21 6.42V80.4A50.11 50.11 0 0 1 812 74.71c16.78 0 27.72 9.48 27.72 24.51v42.9h-11.81v-5.26c-3.36 3.65-11.09 7.44-19.7 7.44-16.05 0-27.28-9.19-27.28-22.17Zm47.27 0c0-7.88-9.63-11.53-18.38-11.53s-17.08 3.65-17.08 11.53 8.32 11.52 17.08 11.52 18.38-3.5 18.38-11.52ZM863.5 164V76.75h11.82v8.76c6.28-7.3 13.72-10.8 22.47-10.8 16.05 0 32.68 12.69 32.68 34.43 0 19.7-14.3 34.73-32.68 34.73a28.86 28.86 0 0 1-22.47-10.22V164Zm55.15-54.86c0-14-9.19-23.34-22.61-23.34-8.61 0-16.78 5.4-20.72 13.71v19.7A23.26 23.26 0 0 0 896 132.78c13.9 0 22.65-9.05 22.65-23.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStellaswapLogo);
export default __webpack_public_path__ + "static/media/stellaswap-logo.70ec3eea.svg";
export { ForwardRef as ReactComponent };